import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_kids_toys: FaireCategoryEntity = {
  token: "cat_kids-toys",
  type: "category",
  name: "Toys & games",
  level: 2,
  parentToken: "cat_kids-baby",
  href: "/category/toys-games",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
